module.exports = __webpack_public_path__ + "static/media/corporate-services-img16.5ffc5c5c.jpg";